import React, {useMemo} from "react";
import {Box, Button, Grid, Typography} from "@mui/material";
import Table from "../../../components/table/tableHistory";

import paypal from "../../../assets/images/paypal.svg";
import pending from "../../../assets/images/pending.svg";
import success from "../../../assets/images/success.svg";
import failed from "../../../assets/images/failed.svg";
import {FileIcon} from "../../../assets/svgFile";
import "./referralPayouts.css";
import EditableInput from "../../../components/editableText";
import {useProfile, useUpdateProfileData} from "../../../graphql/graphql/profile/hooks";
import LoadingWall from "../../../components/loadingWall";

/*const payoutHeader = ["Type", "Credits Redeemed", "USD", "PayPal Email Address", "Date", "Status"];

const payoutHistoryData = [
  {
    Type: <FileIcon />,
    "Credits Redeemed": "100 credits",
    USD: "$10.00 USD",
    "PayPal Email Address": "paypalemail@email.com",
    Date: "Dec 08, 2022 - 12:53 PM",
    Status: (
      <span className="statusPending">
        <img src={pending} alt="status" />
        Pending
      </span>
    ),
  },
  {
    Type: <FileIcon />,
    "Credits Redeemed": "200 credits",
    USD: "$20.00 USD",
    "PayPal Email Address": "paypalemail@email.com",
    Date: "Dec 08, 2022 - 12:53 PM",
    Status: (
      <span className="statusPending statusSuccess">
        <img src={success} alt="status" />
        Success
      </span>
    ),
  },
  {
    Type: <FileIcon />,
    "Credits Redeemed": "200 credits",
    USD: "$20.00 USD",
    "PayPal Email Address": "paypalemail@email.com",
    Date: "Dec 08, 2022 - 12:53 PM",
    Status: (
      <span className="statusPending statusSuccess">
        <img src={success} alt="status" />
        Success
      </span>
    ),
  },
  {
    Type: <FileIcon />,
    "Credits Redeemed": "100 credits",
    USD: "$10.00 USD",
    "PayPal Email Address": "paypalemail@email.com",
    Date: "Dec 08, 2022 - 12:53 PM",
    Status: (
      <span className="statusPending statusFailed">
        <img src={failed} alt="status" />
        Failed
      </span>
    ),
  },
  {
    Type: <FileIcon />,
    "Credits Redeemed": "100 credits",
    USD: "$10.00 USD",
    "PayPal Email Address": "paypalemail@email.com",
    Date: "Dec 08, 2022 - 12:53 PM",
    Status: (
      <span className="statusPending statusSuccess">
        <img src={success} alt="status" />
        Success
      </span>
    ),
  },
  {
    Type: <FileIcon />,
    "Credits Redeemed": "100 credits",
    USD: "$10.00 USD",
    "PayPal Email Address": "paypalemail@email.com",
    Date: "Dec 08, 2022 - 12:53 PM",
    Status: (
      <span className="statusPending statusSuccess">
        <img src={success} alt="status" />
        Success
      </span>
    ),
  },
  {
    Type: <FileIcon />,
    "Credits Redeemed": "100 credits",
    USD: "$10.00 USD",
    "PayPal Email Address": "paypalemail@email.com",
    Date: "Dec 08, 2022 - 12:53 PM",
    Status: (
      <span className="statusPending statusSuccess">
        <img src={success} alt="status" />
        Success
      </span>
    ),
  },
  {
    Type: <FileIcon />,
    "Credits Redeemed": "100 credits",
    USD: "$10.00 USD",
    "PayPal Email Address": "paypalemail@email.com",
    Date: "Dec 08, 2022 - 12:53 PM",
    Status: (
      <span className="statusPending statusFailed">
        <img src={failed} alt="status" />
        Failed
      </span>
    ),
  },
  {
    Type: <FileIcon />,
    "Credits Redeemed": "100 credits",
    USD: "$10.00 USD",
    "PayPal Email Address": "paypalemail@email.com",
    Date: "Dec 08, 2022 - 12:53 PM",
    Status: (
      <span className="statusPending statusSuccess">
        <img src={success} alt="status" />
        Success
      </span>
    ),
  },
];*/

const ReferralPayouts = () => {
  const {updatePayoutMethod, loading} = useUpdateProfileData();
  const {data, loading: payoutLoading} = useProfile();
  //console.log("🚀 ~ file: referralPayouts.jsx:139 ~ ReferralPayouts ~ data:", data);
  const payoutDetail = useMemo(
    () => [
      {
        icon: <img src={paypal} alt="paypal" />,
        name: "email",
        title: "paypal email address (for payouts)",
        detail: data?.payoutMethod?.email,
        placeholder: "paypal email",
      },
      {
        name: "name",
        title: "paypal full Name",
        detail: data?.payoutMethod?.name,
        placeholder: "paypal name",
      },
    ],
    [data]
  );
  if (payoutLoading) return <LoadingWall />;
  return (
    <Box className="referralMain">
      <Typography variant="h4" className="setting_page_heading mb_0">
        Referral Payouts
      </Typography>
      <Box className="content">
        {payoutDetail.map((ac, key) => (
          <EditableInput
            {...ac}
            onSave={updatePayoutMethod}
            loading={loading}
            onSuccessMessage="Payment details updated successfully"
            key={key}
          />
        ))}

        {/* Credits redeemed */}
        <Box className="acDetails !pb-3">
          <Typography
            className="text-white"
            textTransform="uppercase"
            color="rgba(255, 255, 255, 0.6)"
            fontWeight={700}
            fontSize="0.75rem"
            letterSpacing="1.25px"
          >
            Total credits redeemed
          </Typography>

          <Box display="flex" alignItems="center" flexWrap="wrap" justifyContent="space-between">
            <Typography
              sx={{
                textTransform: "unset !important",
                color: "rgba(255, 255, 255, 0.87)",
                letterSpacing: "0.5px",
                mt: "5px",
              }}
            >
              0 (0 USD)
            </Typography>
            <FileIcon style={{cursor: "pointer"}} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ReferralPayouts;
